import React, { useEffect } from 'react'
import { StyledChatItem } from './ChatItem.style';
import Image from '@/Components/atoms/Image';
import { IMessageOfferParsedText, IOfferedBuyProductDto, MessageTypeEnum, OfferStatusEnum } from '@/Models/Chat';
import { getImageUrlByPath } from '@/Services/Image';
import { DateService } from '@/Services/DateService';
import { useTranslation } from 'next-i18next';
import { getColorByLastMessage } from '../helpers/getColorByLastMessage';
import { getDescriptionByItem } from '../helpers/getDescriptionByItem';
import OfferApi from '@/Services/Axios/Controllers/OfferApi';

type Props = {
  item: IOfferedBuyProductDto;
  onSelect?: (id: number) => void;
}

const ChatBuyItem = ({ item, onSelect }: Props) => {
  const { t } = useTranslation();

  const onClick = () => {
    onSelect && onSelect(item.chatId);
    item.newMessageCount = 0;

    OfferApi.getOfferById(item.chatId);
  }

  let [description, last_offer_msg] = getDescriptionByItem(item, t);


  return (
    <StyledChatItem className='chat-item' onClick={onClick}>
      <div className='chat-item__inner'>
        <div className='chat-item__img-wrapper'>
          <Image className='chat-item__img' src={getImageUrlByPath(item.imagePath, 200, 200)} alt='' />
        </div>
        <div className='chat-item__text-wrapper'>
          <div className='chat-item__title-wrapper'>
            <h5 className='chat-item__title'>{item.name}</h5>
            {/* <span className='chat-item__date'>
              {DateService.toHHMM(item.createdAt)}
            </span> */}
            {
              item.offerPrice && (
                <span className='chat-item__offerPrice'>
                  {item.offerPrice} {item.currencyType}
                </span>
              )
            }
          </div>
          <div className="chat-item__description-wrapper">
            <p className='chat-item__description'
              style={getColorByLastMessage(item.messageType, last_offer_msg.status)}
            >{description}</p>
            {
              item.newMessageCount > 0 && (
                <span className='chat-item__newMessageCount'>
                  {item.newMessageCount}
                </span>
              )
            }
          </div>
        </div>
      </div>
    </StyledChatItem>
  )
}

export default ChatBuyItem;
